import { SkeletonDesignTokens } from '@primeuix/themes/types/skeleton';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/skeleton/index.ts
const sk = componentCommon.skeleton;
const skCs = componentColorScheme.skeleton;

export const SkeletonTelekomDT: SkeletonDesignTokens = {
  root: {
    borderRadius: t(sk.border.radius),
  },
  colorScheme: {
    light: {
      root: {
        background: t(skCs.background),
      },
    },
  },
};
